import React, { useEffect } from 'react';
import { Box, Button, Container, Link, Grid, Stepper, Step, StepLabel, Typography, LinearProgress } from '@mui/material';
import { useAppSelector } from 'src/app/react/hooks/redux';
import { base64toDocument, formatPrice } from '../../../shared/utils';
import { DepositPayment } from 'src/app/react/models/purchase/payment-purchase-response.model';
interface FinishPurchaseProps {
    onPaymentFail: () => void;
}

export const FinishPurchase = ({ onPaymentFail }: FinishPurchaseProps) => {

    const { purchase, summary, paymentSuccess, loading, paymentLoading, errorMessage } = useAppSelector(state => state.purchase);

    useEffect(() => {
    },[paymentSuccess])

    const handleViewDocument = (data: string, fileName: string, fileExtension: string, isPaymentBoleto: boolean, isImage?: boolean) => {
        base64toDocument(data, fileName, fileExtension, isPaymentBoleto, isImage); 
    }

    const handlePaymentNavigation = (deposit: DepositPayment) => {
        deposit?.pixInfo ? deposit.pixInfo.value = summary?.total : null;
        sessionStorage.setItem('currentDeposit', JSON.stringify(deposit));
        window.location.href=`/portal/depositos-pagamentos/list/${deposit?.depositId}`;
    }

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Box className="component-box mt-2" sx={{
                        minHeight: 300, 
                        display: 'flex', 
                        flexWrap: 'nowrap',
                        flexDirection: 'column',
                        justifyContent: 'center', 
                        alignContent: 'center',
                        textAlign: 'center',
                        padding: '0 10%'
                    }}>
                                                
                    {paymentLoading && 
                        <Box>
                            <Typography variant="h5">
                                Estamos finalizando sua solicitação de recarga, aguarde mais alguns intantes...
                            </Typography>
                            <LinearProgress sx={{margin: '0 20%'}} />
                        </Box>
                    }
                    {(!paymentLoading && !paymentSuccess) &&
                        <Box>
                            <Typography variant="h5">
                                Ops... Não conseguimos finalizar sua recarga
                            </Typography>
                            <Typography variant="body1">
                                {errorMessage}
                            </Typography>
                            <Button variant="outlined" className='mt-3' onClick={() => onPaymentFail()}>
                                Tentar Novamente
                            </Button>
                        </Box>
                    }
                    {(!paymentLoading && paymentSuccess) &&
                    <>
                        <Box>
                            <Typography variant="h5">
                                Sua solicitação de recarga foi realizada com sucesso!
                            </Typography>
                        </Box>
                        <Box>
                            <Typography variant="body1">
                                Para mais detalhes <a href={`portal/minhasrecargas/details/${purchase.purchaseId}`}>clique aqui</a>
                            </Typography>
                        </Box>
                        { (purchase.deposit?.boletoInfo || purchase.deposit?.pixInfo) &&         
                            <Box className='mt-3'>
                                <Typography variant="body1">
                                    Para esta recarga ser processada é necessário inclur créditos
                                </Typography>
                                <Button 
                                    variant="contained" 
                                    className='mt-2' 
                                    sx={{textTransform: 'none'}}
                                    onClick={() => handlePaymentNavigation(purchase.deposit)}
                                >
                                    Clique aqui para realizar o pagameto
                                </Button> 
                            </Box>
                        }
                        { /* Comentado dia 04/10/22 - TD-1010 */ }
                        {/* { purchase.deposit?.boletoInfo  &&                    
                            <Box className='mt-3'>
                                <Typography variant="body1">
                                    Para esta recarga ser processada é necessário inclur créditos
                                </Typography>                                
                                <Button variant="contained" className='mt-2' onClick={() => handleViewDocument(purchase.deposit?.boletoInfo?.pdf, `boleto_${purchase.deposit?.depositId}`,'pdf', true)}>
                                    Baixar Boleto
                                </Button>
                            </Box>
                        }
                        { purchase.deposit?.pixInfo  &&                    
                            <Box className='mt-3'>
                                <Typography variant="body1">
                                    { purchase.deposit?.pixInfo?.brCode }
                                </Typography>
                                <Button variant="contained" className='mt-2' >
                                    <a style={{color: '#fff'}} download={"pix_"+purchase.deposit?.depositId+".png"} href={"data:image/png;base64,"+purchase.deposit?.pixInfo?.brCodeImage}>
                                        Baixar QR Code
                                    </a>
                                </Button>
                            </Box>
                        } */}
                    </>
                    }
                </Box>
            </Grid>
        </Grid>
    );
}
